import { render } from "./AdminPanelNav.vue?vue&type=template&id=07825ddf&scoped=true"
import script from "./AdminPanelNav.vue?vue&type=script&lang=js"
export * from "./AdminPanelNav.vue?vue&type=script&lang=js"

import "./AdminPanelNav.vue?vue&type=style&index=0&id=07825ddf&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07825ddf"]])

export default __exports__